import { Button } from '@mantine/core';

import { activateSubscriptionRecord, cancelSubscriptionRecord } from '../services/SubscriptionsService';
import { notifications } from '@mantine/notifications';
import { useState } from 'react';
import { Subscription } from '../types';
import { useQueryClient } from '@tanstack/react-query';

export const SubscriptionActions = ({ subscription, onSuccess }: { subscription: Subscription, onSuccess?: () => void }) => {
    const [loading, setLoading] = useState(false);
    const queryClient = useQueryClient();
    
    const handleCancel = async () => {
        setLoading(true);
        try {
            await cancelSubscriptionRecord(subscription.id, queryClient);
            notifications.show({
                title: 'Success',
                message: 'Subscription cancelled successfully',
                color: 'green'
            });
            if (onSuccess) {
                onSuccess();
            }
        } catch (error) {
            notifications.show({
                title: 'Error',
                message: 'Failed to cancel subscription',
                color: 'red'
            });
        } finally {
            setLoading(false);
        }
    };
    
    const handleActivate = async () => {
        setLoading(true);
        try {
            await activateSubscriptionRecord(subscription.id, queryClient);
            notifications.show({
                title: 'Success',
                message: 'Subscription activated successfully',
                color: 'green'
            });
            if (onSuccess) {
                onSuccess();
            }
        } catch (error) {
            notifications.show({
                title: 'Error',
                message: 'Failed to activate subscription',
                color: 'red'
            });
        } finally {
            setLoading(false);
        }
    };
    
    const isActive = subscription.status === 'Active';
    
    return (
        <div style={{ display: 'flex', gap: '8px' }}>
            {isActive ? (
                <Button
                    size="xs"
                    color="red"
                    variant="light"
                    loading={loading}
                    onClick={handleCancel}
                >
                    Cancel
                </Button>
            ) : (
                <Button
                    size="xs"
                    color="green"
                    variant="light"
                    loading={loading}
                    onClick={handleActivate}
                >
                    Activate
                </Button>
            )}

        </div>
    );
};


